import state from '../store/state.js';
// 开发环境不使用懒加载, 因为懒加载页面太多的话会造成webpack热更新太慢
const _import = require('./import-' + process.env.NODE_ENV)

function getProps (route) {
  return route.query;
}

// 系统生成路由
const routers = [
  { path: '/login', component: _import('login/index'), name: 'login', props: getProps, desc: '登录' },
  {
    path: '/',
    component: _import('login/index'),
    name: 'root'
  },
  {
    path: '/main',
    component: _import('layout/index'),
    name: 'main',
    props: getProps,
    redirect: {
      name: 'welcome'
    },
    meta: {
      title: '主页',
      showOnly: true
    },
    children: [
      {path: 'formSysUser', component: _import('upms/formSysUser/index'), name: 'formSysUser', meta: {title: '用户管理'}},
      {path: 'formSysDept', component: _import('upms/formSysDept/index'), name: 'formSysDept', meta: {title: '部门管理'}},
      {path: 'formSysRole', component: _import('upms/formSysRole/index'), name: 'formSysRole', meta: {title: '角色管理'}},
      {path: 'formSysDataPerm', component: _import('upms/formSysDataPerm/index'), name: 'formSysDataPerm', meta: {title: '数据权限管理'}},
      {path: 'formSysMenu', component: _import(state.supportColumn ? 'upms/formSysMenu/formSysColumnMenu' : 'upms/formSysMenu/index'), name: 'formSysMenu', meta: {title: '菜单列表'}},
      {path: 'formSysDict', component: _import('upms/formDictManagement/index'), name: 'formSysDict', meta: {title: '字典管理'}},
      {path: 'formSysPermCode', component: _import('upms/formSysPermCode/index'), name: 'formSysPermCode', meta: {title: '权限字管理'}},
      {path: 'formSysPerm', component: _import('upms/formSysPerm/index'), name: 'formSysPerm', meta: {title: '权限资源管理'}},
      {path: 'formSysLoginUser', component: _import('upms/formSysLoginUser/index'), name: 'formSysLoginUser', meta: {title: '在线用户'}},
      // 岗位模块路由配置
      {path: 'formSysPost', component: _import('upms/formSysPost/index'), name: 'formSysPost', meta: {title: '岗位管理'}},
      {path: 'formSysDeptPost', component: _import('upms/formSysDeptPost/index'), name: 'formSysDeptPost', props: getProps, meta: {title: '设置部门岗位'}},
      // 在线表单模块路由配置
      {path: 'formOnlineDict', component: _import('onlineForm/formOnlineDict/index'), name: 'formOnlineDict', props: getProps, meta: {title: '在线表单字典管理'}},
      {path: 'formOnlinePage', component: _import('onlineForm/formOnlinePage/index'), name: 'formOnlinePage', props: getProps, meta: {title: '在线表单管理'}},
      {path: 'onlineForm', component: _import('onlineForm/index'), name: 'onlineForm', props: getProps, meta: {title: '在线表单'}},
      // 工作流模块路由配置
      {path: 'formMessage', component: _import('workflow/formMessage/index'), name: 'formMessage', props: getProps, meta: {title: '催办消息'}},
      {path: 'formFlowCategory', component: _import('workflow/flowCategory/formFlowCategory'), name: 'formFlowCategory', props: getProps, meta: {title: '流程分类管理'}},
      {path: 'formFlowEntry', component: _import('workflow/flowEntry/formFlowEntry'), name: 'formFlowEntry', props: getProps, meta: {title: '流程设计'}},
      {path: 'formAllInstance', component: _import('workflow/taskManager/formAllInstance'), name: 'formAllInstance', props: getProps, meta: {title: '流程实例'}},
      {path: 'formMyTask', component: _import('workflow/taskManager/formMyTask'), name: 'formMyTask', props: getProps, meta: {title: '我的待办'}},
      {path: 'formMyApprovedTask', component: _import('workflow/taskManager/formMyApprovedTask'), name: 'formMyApprovedTask', props: getProps, meta: {title: '已办任务'}},
      {path: 'formMyHistoryTask', component: _import('workflow/taskManager/formMyHistoryTask'), name: 'formMyHistoryTask', props: getProps, meta: {title: '历史流程'}},
      {
        path: 'handlerFlowTask',
        component: _import('workflow/handlerFlowTask/index'),
        name: 'handlerFlowTask',
        props: getProps,
        meta: {title: '流程处理'},
        children: [
          // 静态表单路由设置
        ]
      },
      {path: 'welcome', component: _import('welcome/index'), name: 'welcome', meta: {title: '欢迎'}},
      {
        path: 'UserInfoManage',
        component: _import('UserInfo/userInfoManage'),
        name: 'UserInfoManage',
        props: getProps,
        meta: {title: '员工信息管理'}
      },
      {
        path: 'EditUserInfo',
        component: _import('UserInfo/editUserInfo'),
        name: 'EditUserInfo',
        props: getProps,
        meta: {title: '编辑员工'}
      },
      {
        path: 'JobTitleManage',
        component: _import('JobTitle/jobTitleManage'),
        name: 'JobTitleManage',
        props: getProps,
        meta: {title: '职称管理'}
      },
      {
        path: 'JobLevelManage',
        component: _import('JobLevel/jobLevelManage'),
        name: 'JobLevelManage',
        props: getProps,
        meta: {title: '职级管理'}
      },
      {
        path: 'PaIndexModelManage',
        component: _import('PaIndex/paIndexModelManage'),
        name: 'PaIndexModelManage',
        props: getProps,
        meta: {title: '指标模型管理'}
      },
      {
        path: 'SysDict',
        component: _import('SysDict/sysDict'),
        name: 'SysDict',
        props: getProps,
        meta: {title: '系统字典'}
      },
      {
        path: 'PaIndexGroupManage',
        component: _import('PaIndex/paIndexGroupManage'),
        name: 'PaIndexGroupManage',
        props: getProps,
        meta: {title: '薪资组管理'}
      },
      {
        path: 'JobLevelRecord',
        component: _import('JobLevel/jobLevelRecord'),
        name: 'JobLevelRecord',
        props: getProps,
        meta: {title: '定岗记录'}
      },
      {
        path: 'PaPayroll',
        component: _import('PaPayroll/paPayroll'),
        name: 'PaPayroll',
        props: getProps,
        meta: {title: '薪资发放计划'}
      },
      {
        path: 'PayrollUserSalaryRecord',
        component: _import('PaPayroll/payrollUserSalaryRecord'),
        name: 'PayrollUserSalaryRecord',
        props: getProps,
        meta: {title: '薪资记录'}
      },
      {
        path: 'EditPayrollUserSalary',
        component: _import('PaPayroll/editPayrollUserSalary'),
        name: 'EditPayrollUserSalary',
        props: getProps,
        meta: {title: '配置人员薪资组'}
      },
      {
        path: 'WorkLvScore',
        component: _import('WorkManage/workLvScore'),
        name: 'WorkLvScore',
        props: getProps,
        meta: {title: '作品级别分值表'}
      },
      {
        path: 'WorkLvMoney',
        component: _import('WorkManage/workLvMoney'),
        name: 'WorkLvMoney',
        props: getProps,
        meta: {title: '稿件级别管理'}
      },
      {
        path: 'userWorkDraft',
        component: _import('WorkManage/userWorkDraft'),
        name: 'userWorkDraft',
        props: getProps,
        meta: {title: '稿件记录'}
      },
      {
        path: 'PaWorkManage',
        component: _import('WorkManage/paWorkManage'),
        name: 'PaWorkManage',
        props: getProps,
        meta: {title: '作品管理'}
      },
      {
        path: 'UserWorkList',
        component: _import('WorkManage/userWorkList'),
        name: 'UserWorkList',
        props: getProps,
        meta: {title: '人员作品列表'}
      },
      {
        path: 'AttnFlowList',
        component: _import('AttnManage/AttnFlowList'),
        name: 'AttnFlowList',
        props: getProps,
        meta: {title: '请假记录'}
      },
      {
        path: 'SignRecordList',
        component: _import('AttnManage/SignRecordList'),
        name: 'SignRecordList',
        props: getProps,
        meta: {title: '打卡记录'}
      },
      {
        path: 'AttnGroupList',
        component: _import('AttnManage/attnGroupList'),
        name: 'AttnGroupList',
        props: getProps,
        meta: {title: '考勤组'}
      },
      {
        path: 'EditAttnGroup',
        component: _import('AttnManage/editAttnGroup'),
        name: 'EditAttnGroup',
        props: getProps,
        meta: {title: '编辑考勤组'}
      },
      {
        path: 'PaNotifyManage',
        component: _import('PaNotify/paNotifyManage'),
        name: 'PaNotifyManage',
        props: getProps,
        meta: {title: '公告管理'}
      }
    ]
  }
];

export default routers;
